// @flow
/* eslint no-unreachable: 0 */

import { combineReducers } from 'redux';
import { normalize, schema } from 'normalizr';
import merge from 'lodash/merge';

import type { ThunkAction } from '../../types/redux';

import type { Article } from '../../types/model';

import { getArticle } from '../../api';

import { RECEIVE_CATEGORY_FULFILLED } from './categories';

export const RECEIVE_ARTICLE_PENDING = 'RECEIVE_ARTICLE_PENDING';
export const RECEIVE_ARTICLE_FULFILLED = 'RECEIVE_ARTICLE_FULFILLED';
export const RECEIVE_ARTICLE_REJECTED = 'RECEIVE_ARTICLE_REJECTED';

export const RECEIVE_ALL_ARTICLES_PENDING = 'RECEIVE_ALL_ARTICLES_PENDING';
export const RECEIVE_ALL_ARTICLES_FULFILLED = 'RECEIVE_ALL_ARTICLES_FULFILLED';
export const RECEIVE_ALL_ARTICLES_REJECTED = 'RECEIVE_ALL_ARTICLES_REJECTED';

export type State = {
  allError: null | string,
  allLoading: boolean,
  all: Array<number>,
  byId: { [key: number]: Article }
}

const articleSchema = new schema.Entity('articles');
// const allArticlesSchema = [articleSchema];

export function requestArticle(id: number) : ThunkAction {
  return (dispatch, getState, { axios }) => {
    const { intl: { locale } } = getState();

    dispatch({ type: RECEIVE_ARTICLE_PENDING });

    return getArticle(id, locale)
      .then(({ data }) => normalize(data, articleSchema))
      .then(normalizedData => {
        return dispatch({
          type: RECEIVE_ARTICLE_FULFILLED,
          payload: normalizedData
        });
      }, error => {
        return dispatch({
          type: RECEIVE_ARTICLE_REJECTED,
          payload: error.message
        })
      })
  };
}

function fakeAllRequest() {
  return new Promise((resolve, reject) => {
    setTimeout(() => resolve({ data: [] }), 1000)
  })
}

export function requestAllArticles() : ThunkAction {
  return (dispatch, getState, { axios }) => {
    // const { intl: { locale } } = getState();
    dispatch({
      type: RECEIVE_ALL_ARTICLES_PENDING,
    });

    return fakeAllRequest()
      .then(({ data }) => {
        return dispatch({
          type: RECEIVE_ALL_ARTICLES_FULFILLED,
          payload: data
        });
      })
      .catch(error => {
        return dispatch({
          type: RECEIVE_ALL_ARTICLES_REJECTED,
          payload: error.message
        })
      })
  };
}

function allLoading(state = false, action) {
  switch (action.type) {
    case RECEIVE_ALL_ARTICLES_PENDING:
      return true
    case RECEIVE_ALL_ARTICLES_FULFILLED:
    case RECEIVE_ALL_ARTICLES_REJECTED:
      return false;
    default:
      return state;
  }
}

function allError(state = null, action) {
  switch (action.type) {
    case RECEIVE_ALL_ARTICLES_REJECTED:
      return action.payload;
    case RECEIVE_ALL_ARTICLES_PENDING:
    case RECEIVE_ALL_ARTICLES_FULFILLED:
      return null;
    default:
      return state;
  }
}

function all(state = [], action) {
  switch (action.type) {
    case RECEIVE_ALL_ARTICLES_FULFILLED:
      return action.payload.map(cat => cat.id);
    default:
      return state;
  };
}

function byId(state = {}, action) {
  switch (action.type) {
    case RECEIVE_ALL_ARTICLES_FULFILLED:
      return action.payload.reduce((prev, curr) => ({ ...prev, [curr.id]: curr }), state)
    case RECEIVE_ARTICLE_FULFILLED:
    case RECEIVE_CATEGORY_FULFILLED:
      return merge({}, state, action.payload.entities.articles);
    default:
      return state;
  };
}

export const selectors = {
  getAll: (state: State): Array<Article> => {
    return state.all
      .map(id => state.byId[id]);
  },
  getById: (state: State, id: number): ?Article => {
    return state.byId[id];
  },
}

export default combineReducers({
  allError,
  allLoading,
  all,
  byId,
});



// WEBPACK FOOTER //
// ./src/redux/modules/articles.js